import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const getById = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.CUSTOMER_NOTE}/${id}`,
    method: 'GET',
  });

const create = content =>
  request({
    baseURL: API.BASE_URL,
    url: API.CUSTOMER_NOTE,
    method: 'POST',
    data: content,
  });

const update = content =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.CUSTOMER_NOTE}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const patch = ({ id, ...content }) =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.CUSTOMER_NOTE}/${id}`,
    method: 'PATCH',
    data: content,
  });

const remove = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.CUSTOMER_NOTE}/${id}`,
    method: 'DELETE',
  });

const getByOwner = (customerId, page) =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.CUSTOMER_NOTE}`,
    method: 'GET',
    params: {
      page: page || 1,
      pageSize: 5,
      filter: [
        {
          type: 'eq',
          field: 'customer',
          value: customerId,
        },
      ],
    },
    paramsSerializer: params => qs.stringify(params),
  });

const NoteService = {
  getByOwner,
  getById,
  create,
  update,
  patch,
  remove,
};

export default NoteService;
